var _rect, _path, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagEnglish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1235,
    height: 650,
    viewBox: "0 0 7410 3900",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7410,
    height: 3900,
    fill: "#b22234"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,450H7410m0,600H0m0,600H7410m0,600H0m0,600H7410m0,600H0",
    stroke: "#fff",
    strokeWidth: 300
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2964,
    height: 2100,
    fill: "#3c3b6e"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s",
    d: "M247,90 317.534230,307.082039 132.873218,172.917961H361.126782L176.465770,307.082039z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    y: 420
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    y: 840
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    y: 1260
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    y: 1680
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s4",
    x: 247,
    y: 210
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s9",
    x: 494
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s18",
    x: 988
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s9",
    x: 1976
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s5",
    x: 2470
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEnglish);
export default __webpack_public_path__ + "static/media/flag_english.262c6f5c7f0d58e0f3b79974a08dd800.svg";
export { ForwardRef as ReactComponent };